import {performRequest} from 'shared/utils';

import {TJasperReportInfo} from './jasper-report-slice-types';

export const getJasperReportUrl = (entityName: string) => (
    performRequest<string>({
        url: '/report/getUrl',
        method: 'GET',
        params: {name: entityName},
    })
);

export interface IGetJasperReportInfoData extends TJasperReportInfo {}

export const getJasperReportInfo = (url: string) => (
    performRequest<IGetJasperReportInfoData>({
        url,
        method: 'GET',
    })
);
